import React from 'react'
import './InfinityLoading.css'

export const InfinityLoading = () => {
  return <div className="progress-line"></div>
}



// WEBPACK FOOTER //
// ./src/component/Loading/InfinityLoading.js